import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IPostCancelEnrollmentByEnrollmentId {
  merchantId: number;
  enrollmentId: number
}

export async function postCancelEnrollmentByEnrollmentId(data: IPostCancelEnrollmentByEnrollmentId): Promise<any> {
  try {
    return (await axiosInstance.post("/MerchantSoftPOSEnrollment/CancelMerchantEnrollmentById?merchantId=" + data.merchantId + `&enrollmentId=${data.enrollmentId}`, null)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}